import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import Modal from 'react-bootstrap/Modal';
import { HomePage } from '../../translations/trans';
import { urlBase } from '../../utils/API';
const ViewHw = ({ session, show,
    handleClose }) => {
    const { lang, dir } = useSelector(({ language }) => {
        return { lang: language.lang, dir: language.dir };
    });

    const [homework, setHomeWork] = useState([]);

    const loggedUser = useSelector((state) => state.loggedUser)

    useEffect(() => {
        if (show) {
            const homeworkdata = session?.homeWork
                ?.filter((hw) => {
                    const studentId = hw?.student?._id || hw?.student;
                    return studentId?.toString() === loggedUser?.user?._id?.toString();
                })
                .sort((first, second) => (first.index || 0) - (second.index || 0));
            setHomeWork(homeworkdata || []);
        }
    }, [show, session, loggedUser?.user?._id])

    return (
        <div>
            <div>
                {/* <button className='mx-3' onClick={handleShow}
                    
                    style={{ color: "white", background: "#283476", padding: "10px", borderRadius: "10px", border: "none" }}>
                    {HomePage.viewHW[lang]}

                </button> */}

                <Modal show={show} onHide={handleClose} centered className='py-5' dir={dir}>
                    <Modal.Body>
                        {
                            homework.length > 0 ? (
                                homework.map((hw, index) => (
                                    <div className="mt-3" key={hw._id || hw.file}>
                                        <p>
                                            {lang === 'AR' ? 'الملف' : 'File'} {hw.index || index + 1} / {homework.length}
                                        </p>
                                        <iframe
                                            src={`${urlBase}/${hw.file}`}
                                            title={`Homework file ${hw.index || index + 1}`}
                                            width="100%"
                                            height="500px"
                                            style={{ border: 'none' }}
                                        />
                                    </div>
                                ))
                            ) : (
                                <div className="text-center mt-3">
                                    <p>{lang === 'AR' ? 'لا يوجد بيانات للعرض' : 'No data available to display'}</p>
                                </div>
                            )
                        }
                    </Modal.Body>

                </Modal>
            </div>
        </div>
    )
}

export default ViewHw
